import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { StudentTimelineDateFrame, YearMonth } from '../../../_models/timeline-models/student-timeline-frame.model';
import { Location } from "@angular/common";
import { TimelineNavHelperService } from '../../../_helpers/timeline-nav-helper/timeline-nav-helper.service';
@Component({
    selector: 'app-timeline-nav',
    templateUrl: './timeline-nav.component.html',
    styleUrls: ['./timeline-nav.component.css'],
    standalone: false
})
export class TimelineNavComponent implements OnInit, OnChanges {

  @Input() timelineDateFrame: StudentTimelineDateFrame[];

  public recordedYears: string[];
  public currentYear: number;
  public firstYear: number;
  public lastYear: number;
  public months: YearMonth[];
  public plusBtnDisabled: boolean;
  public minusBtnDisabled: boolean;


  constructor(
    private element: ElementRef,
    private timelineNavService: TimelineNavHelperService,
    private location: Location
  ) { }

  ngOnInit() {
    this.getDistinctYears();

    let d = new Date();
    this.currentYear = d.getFullYear();
    this.buildNavControls();

    this.timelineNavService.direction.subscribe(direction => {
      if (direction != null && this.recordedYears != null) {
        if (direction == 'forward') {
          this.incrementYear();
        }
        else {
          this.decrementYear();
        }
      }
    });

  }

  public getDistinctYears() {
    let tmpYears = [];
    this.timelineDateFrame.forEach(x => {
      tmpYears.push(x.yearLabel);
    });
    this.recordedYears = tmpYears.sort();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.timelineDateFrame != null && this.currentYear) {
      this.buildNavControls();
    }
  }

  public buildNavControls() {
    // Get a list of the recorded years in the array.

    this.firstYear = +(this.recordedYears[0]);
    this.lastYear = +(this.recordedYears[this.recordedYears.length - 1]);

    let arr: StudentTimelineDateFrame[] = this.timelineDateFrame.filter(x =>
      x.yearLabel == this.currentYear.toString()
    );

    let arr2: StudentTimelineDateFrame = arr[0];

    if (arr2 != null) {
      this.months = arr2.months;
    }

    this.checkbtnState();
  }

  public gotoYear() {
    this.checkbtnState();
    this.scrollIntoView(this.currentYear, 1);
  }


  public incrementYear() {
    // Find the currentYear in the recordedYears array.    
    let i = this.recordedYears.indexOf(this.currentYear.toString());

    // Go to the next year in the array, if possible.
    if (i < this.recordedYears.length - 1) {
      this.currentYear = +(this.recordedYears[i + 1]);
      this.scrollIntoView(this.currentYear, 1);
    }
    this.checkbtnState();
    this.buildNavControls();
  }


  public decrementYear() {
    // Find the currentYear in the recordedYears array.
    let i = this.recordedYears.indexOf(this.currentYear.toString());

    // Go to the previous year in the array, if possible.
    if (i > 0) {
      this.currentYear = +(this.recordedYears[i - 1]);
      this.scrollIntoView(this.currentYear, 1);
    }
    this.checkbtnState();
    this.buildNavControls();
  }


  public checkbtnState() {

    if (this.currentYear < this.lastYear) {
      this.plusBtnDisabled = false;
    }
    else {
      this.plusBtnDisabled = true
    }

    if (this.currentYear > this.firstYear) {
      this.minusBtnDisabled = false;
    }
    else {
      this.minusBtnDisabled = true;
    }
  }


  public scrollIntoView(year: number, month: number) {
    this.timelineNavService.isNavigating = true;
    setTimeout(() => {
      this.timelineNavService.isNavigating = false;
    }, 2000);

    let anchor = year + ('0' + month).slice(-2);

    if (document.getElementById(anchor) != null) {
      document.getElementById(anchor).scrollIntoView({ behavior: "smooth" });
    }
  }



  public isNumber(number: number): boolean {
    return isNaN(+number);
  }

}
